import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-task-num" }

import { ref, withDefaults } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  XrkTableRef,
  useInputColumn,
  BaseInput
} from 'xrk-components';
import { addTaskNumList } from '../data-source/apis';

export default /*#__PURE__*/_defineComponent({
  __name: 'add-task-num-list',
  props: {
    projectId: { default: null }
  },
  setup(__props: any, { expose: __expose }) {

const xrkTableRef = ref<XrkTableRef>();

const props = __props;
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    useInputColumn({
      label: '姓名',
      prop: 'name',
      type: 'input',
      config: {
        placeholder: '请输入姓名'
      }
    }),
    useInputColumn({
      label: '手机号',
      prop: 'phone',
      type: 'input',
      config: {
        type: 'tel',
        placeholder: '请输入手机号'
      }
    })
  ]
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'userId',
      align: 'center',
      fixed: 'left',
      width: 120
    }),
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    useTableColumn({
      label: '姓名',
      prop: 'name'
    }),
    useTableColumn({
      label: '手机号',
      prop: 'phone'
    }),
    useTableColumn({
      label: '新增任务量',
      prop: 'taskNum',
      render: ({ row }) => {
        return (
          <div>
            <BaseInput
              v-model={row.taskNum}
              type="number"
              placeholder="请输入"
              style={{ width: '100px' }}
            ></BaseInput>
          </div>
        );
      }
    })
  ]
});

const getListAjax = async params => {
  const data = await addTaskNumList({
    ...params,
    projectId: props.projectId
  });
  return data;
};
__expose({
  getSelectData: () => {
    return xrkTableRef.value.getSelectionRows().map(item => {
      return {
        projectId: props.projectId,
        userId: item.userId,
        taskNum: +item.taskNum
      };
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})